import { IStandardTextDrawableObject, instanceOfIStandardTextDrawableObject } from "./IStandardTextDrawableObject";
import { ElementTypes } from "./ElementTypes";

export interface ISelectableObject extends IStandardTextDrawableObject {
}

export function instanceOfISelectableObject<T extends ISelectableObject>(instance: any, type: ElementTypes): instance is ISelectableObject {
  return instance
      && instanceOfIStandardTextDrawableObject<T>(instance, type);
}
